import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    DropdownData,
    InputType,
    ReactiveFormChangedField,
    ReactiveFormValue,
} from '@fitogest/reactive-form-builder/interfaces';
import { list } from 'src/app/common/classes/request-builder';
import { Compradores } from 'src/app/models/ventas/compradores.model';
import { ProductosModel } from 'src/app/models/productos/productos.model';
import { environment } from 'src/environments/environment';

type MaterialInputRule = {
    materialValues: string[];
    visiblePlaceholders: string[];
};

export class ProductosFertilizantesListsDefinition {
    public materialFertilizante: DropdownData<string | null> = list<string | null>(
        ['...', null],
        ['Estiércol líquido de aves', '1'],
        ['Estiércol líquido de bovino', '2'],
        ['Estiércol líquido de porcino', '3'],
        ['Estiércol sólido de aves', '4'],
        ['Estiércol sólido de bovino', '5'],
        ['Estiércol sólido de caprino', '6'],
        ['Estiércol sólido de equino', '7'],
        ['Estiércol sólido de ovino', '8'],
        ['Inhibidores', '9'],
        ['Otros tipos de estiércol sólido: conejo, visón, zorro...', '10'],
        ['Productos fertilizantes bioestimulantes', '11'],
        ['Productos fertilizantes enmiendas calizas', '12'],
        ['Productos fertilizantes enmiendas orgánicas', '13'],
        ['Productos fertilizantes inorgánicos', '14'],
        ['Productos fertilizantes orgánicos', '15'],
        ['Productos fertilizantes organominerales', '16'],
        ['Productos fertilizantes otras enmiendas (retenedoras humedad, ácidas, etc.)', '17'],
        ['Residuos: Materiales que, sin haberse empleado en la elaboración de un producto fertilizante', '18'],
        ['Residuos: Subproductos de origen animal no aptos para consumo humano', '19'],
        ['Residuos: compost de alperujo', '20'],
        ['Residuos: alperujo desecado', '21'],
        ['Residuos: Lodos de tratamiento de aguas residuales urbanas (lodos EDAR)', '22'],
        [
            'Residuos: Lodos calizos procedentes del proceso Kraft de fabricación de pasta de papel, para elevar el pH de suelos ácidos',
            '23',
        ],
    );

    public unidadesCostes: DropdownData<string | null> = list<string | null>(
        ['...', null],
        ['kilos', 'kilos'],
        ['litros', 'litros'],
    );

    public subtipos: DropdownData<string | null> = list<string | null>(
        ['...', null],
        ['A', '1'],
        ['B', '2'],
        ['C', '3'],
    );

    public tiposAbonoOrganico: DropdownData<string | null> = list<string | null>(
        ['...', null],
        ['Estiércol de bovino', 'EB'],
        ['Estiércol de ovino', 'EO'],
        ['Estiércol de porcino', 'EP'],
        ['Purines de porcino', 'PP'],
        ['Gallinaza', 'G'],
        ['Lodos de depuradora', 'L'],
        ['Compost de RSU', 'C'],
        ['Otros', 'O'],
    );

    public empresa: DropdownData<Compradores> = list<Compradores>(['...', null]);
}

export class ProductosFertilizantesFormDefinition {
    private readonly formType!: FormType;

    public readonly lists: ProductosFertilizantesListsDefinition = new ProductosFertilizantesListsDefinition();

    public readonly appName = environment.appName;

    public readonly applicationType = environment.features.applicationType;

    public readonly activateREA = environment.features.activateREA;

    public readonly fertilizantesNombreRequired = environment.features.fertilizantesNombreRequired;

    public readonly showFertilizantesSubtipo = environment.features.showFertilizantesSubtipo;

    public readonly showFertisComposicion = environment.features.showFertisComposicion;

    public readonly showFertilizantesNPK = environment.features.showFertilizantesNPK;

    public readonly showFertilizantesCa = environment.features.showFertilizantesCa;

    public readonly showFertilizantesS = environment.features.showFertilizantesS;

    public readonly showFertilizantesMg = environment.features.showFertilizantesMg;

    public readonly showDescripcion = environment.features.showDescripcion;

    public readonly showPrecio = environment.features.showPrecio;

    public readonly showRoturaStock = environment.features.showFertiRoturaStock;

    public model: ReactiveFormValue<ProductosModel> = {} as ReactiveFormValue<ProductosModel>;

    public lastChangedFieldName: ReactiveFormChangedField<ProductosModel> = '';

    public formFields!: Form<ProductosModel>;

    public fieldNames: FormField<ProductosModel>[] = [];

    public fieldLabels: string[] = [];

    private readonly materialRules: MaterialInputRule[] = [
        {
            materialValues: ['1', '2', '3', '4', '5', '6', '7', '8', '10'],
            visiblePlaceholders: [
                'macronutriente_1',
                'macronutriente_3',
                'macronutriente_4',
                'macronutriente_6',
                'macronutriente_9',
                'macronutriente_14',
                'macronutriente_15',
            ],
        },
        {
            materialValues: ['9', '11', '12', '17'],
            visiblePlaceholders: ['macronutriente_12', 'macronutriente_13'],
        },
        {
            materialValues: ['13', '18', '19', '20', '21', '22'],
            visiblePlaceholders: [
                'macronutriente_1',
                'macronutriente_3',
                'macronutriente_4',
                'macronutriente_6',
                'macronutriente_10',
                'macronutriente_14',
            ],
        },
        {
            materialValues: ['14', '16'],
            visiblePlaceholders: [
                'macronutriente_1',
                'macronutriente_2',
                'macronutriente_4',
                'macronutriente_5',
                'macronutriente_6',
                'macronutriente_7',
                'macronutriente_8',
                'macronutriente_9',
                'macronutriente_12',
            ],
        },
        {
            materialValues: ['15'],
            visiblePlaceholders: [
                'macronutriente_1',
                'macronutriente_3',
                'macronutriente_4',
                'macronutriente_6',
                'macronutriente_10',
                'macronutriente_14',
            ],
        },
        {
            materialValues: ['23'],
            visiblePlaceholders: ['macronutriente_11', 'macronutriente_14'],
        },
    ];

    /**
     * Creates the fertilizer product form definition shared by edit forms and list modals.
     *
     * @constructor
     * @public
     *
     * @param type - Request type used to define the form behaviour.
     * @param model - Optional fertilizer product model used as initial form data.
     * @param table - Optional table configuration used by table-based form modes.
     * @param actions - Optional callbacks used by header buttons.
     *
     * @returns A new fertilizer product form definition instance.
     */
    constructor(
        type: FormType = FormType.CREATION,
        model: Partial<ProductosModel> | null = {},
        table: (string[] | string[][])[] | null = null,
    ) {
        this.formType = +type;
        this.model = {
            ...this.model,
            ...(model ?? {}),
        } as ReactiveFormValue<ProductosModel>;
        this.model.tipo = this.resolveProductType(this.model.tipo);
        this.model.abono_con_inhibidor = this.normalizeSwitchValue(this.model.abono_con_inhibidor);
        this.formFields = this.buildForm(table);
    }// constructor();

    /**
     * Updates the stored model and rebuilds visible section metadata.
     *
     * @public
     *
     * @param model - Partial fertilizer product model received from the reactive form.
     * @param lastChangedFieldName - Last field changed by the user or by the builder.
     *
     * @returns Nothing.
     */
    public updateModel(
        model: ReactiveFormValue<ProductosModel>,
        lastChangedFieldName: ReactiveFormChangedField<ProductosModel>,
    ): void {
        this.model = {
            ...this.model,
            ...model,
            tipo: this.resolveProductType(model.tipo ?? this.model.tipo),
        } as ReactiveFormValue<ProductosModel>;
        this.model.abono_con_inhibidor = this.normalizeSwitchValue(this.model.abono_con_inhibidor);
        this.lastChangedFieldName = lastChangedFieldName;
    }// updateModel();

    /**
     * Rebuilds section visibility and field metadata without replacing dropdown lists.
     *
     * @public
     *
     * @returns Nothing.
     */
    public refreshSections(): void {
        this.fieldNames = [];
        this.fieldLabels = [];
        this.formFields = {
            ...this.formFields,
            sections: this.getFormSections(),
        };
    }// refreshSections();

    /**
     * Builds and returns the main fertilizer product fields using the standard row layout.
     *
     * @public
     *
     * @returns The fertilizer fields sorted by display order.
     */
    public getFertilizerFields(): FormField<ProductosModel>[] {
        const fertilizerFields: FormField<ProductosModel>[] = [
            {
                name: 'nombre',
                vinculatedFields: undefined,
                label: this.appName === 'vginer' ? 'Fertilizante' : 'Nombre o Marca Comercial',
                input: { type: InputType.TEXT, isEditable: this.isEditable() },
                width: 4,
                conditions: this.conditions({ isRequired: this.fertilizantesNombreRequired }),
                order: 1,
            },
            {
                name: 'familia',
                vinculatedFields: undefined,
                label: 'Familia',
                input: { type: InputType.TEXT, isEditable: this.isEditable() },
                width: 4,
                conditions: this.conditions({ isVisible: this.appName === 'agroleza' }),
                order: 2,
            },
            {
                name: 'descripcion',
                vinculatedFields: undefined,
                label: this.appName === 'agropecuariaramirogruas' ? 'Descripción (Tipo Fertilizante)' : 'Descripción',
                input: { type: InputType.TEXTAREA, isEditable: this.isEditable() },
                width: 4,
                conditions: this.conditions({ isVisible: this.showDescripcion }),
                order: 3,
            },
            {
                name: 'composicion',
                vinculatedFields: undefined,
                label: 'Composición',
                input: { type: InputType.TEXT, isEditable: this.isEditable() },
                width: 4,
                conditions: this.conditions({ isVisible: this.showFertisComposicion }),
                order: 4,
            },
            {
                name: 'precio',
                vinculatedFields: undefined,
                label: this.appName === 'agrotata' ? 'Precio Coste' : 'Precio',
                input: { type: InputType.NUMERIC, isEditable: this.isEditable() },
                width: 3,
                conditions: this.conditions({ isVisible: this.showPrecio }),
                order: 5,
            },
            {
                name: 'precio_venta',
                vinculatedFields: undefined,
                label: 'Precio de Venta',
                input: { type: InputType.NUMERIC, isEditable: this.isEditable() },
                width: 3,
                conditions: this.conditions({ isVisible: this.showPrecio && this.appName === 'agrotata' }),
                order: 6,
            },
            {
                name: 'unidades',
                vinculatedFields: undefined,
                label: 'Unidades medida',
                input: {
                    type: InputType.DROPDOWN,
                    isEditable: this.isEditable(),
                    data: this.lists.unidadesCostes,
                },
                width: 3,
                conditions: this.conditions({ isRequired: true }),
                order: 7,
            },
            this.buildNumericField('N', 'N%', 8, 1, this.showFertilizantesNPK),
            this.buildNumericField('P', 'P%', 9, 1, this.showFertilizantesNPK),
            this.buildNumericField('K', 'K%', 10, 1, this.showFertilizantesNPK),
            this.buildNumericField('Ca', 'Ca%', 11, 1, this.showFertilizantesCa),
            this.buildNumericField('S', 'S%', 12, 1, this.showFertilizantesS),
            this.buildNumericField('Mg', 'Mg%', 13, 1, this.showFertilizantesMg),
            {
                name: 'envase',
                vinculatedFields: undefined,
                label: 'Envase',
                input: { type: InputType.TEXT, isEditable: this.isEditable() },
                width: 3,
                conditions: this.conditions(),
                order: 14,
            },
            {
                name: 'tipo_abono_organico',
                vinculatedFields: undefined,
                label: 'Tipo de Abono Orgánico',
                input: {
                    type: InputType.DROPDOWN,
                    isEditable: this.isEditable(),
                    data: this.lists.tiposAbonoOrganico,
                },
                width: 3,
                conditions: this.conditions(),
                order: 15,
            },
            {
                name: 'abono_con_inhibidor',
                vinculatedFields: undefined,
                label: 'Abono con inhibidor de Nitrógeno',
                input: { type: InputType.SWITCH, isEditable: this.isEditable() },
                width: 3,
                conditions: this.conditions(),
                order: 16,
            },
            {
                name: 'rotura_stock',
                vinculatedFields: undefined,
                label: 'Rotura stock',
                input: { type: InputType.NUMERIC, isEditable: this.isEditable() },
                width: 3,
                conditions: this.conditions({ isVisible: this.showRoturaStock }),
                order: 17,
            },
            {
                name: 'subtipo',
                vinculatedFields: undefined,
                label: 'Subtipo',
                input: {
                    type: InputType.DROPDOWN,
                    isEditable: this.isEditable(),
                    data: this.lists.subtipos,
                },
                width: 3,
                conditions: this.conditions({ isVisible: this.showFertilizantesSubtipo }),
                order: 18,
            },
        ];

        this.appendVisibleFields(fertilizerFields);
        return fertilizerFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }// getFertilizerFields();

    /**
     * Builds and returns the first visible fertilizer product fields.
     *
     * @public
     *
     * @returns The top fields sorted by display order.
     */
    public getTopFields(): FormField<ProductosModel>[] {
        const topFields: FormField<ProductosModel>[] = [
            {
                name: 'nombre',
                vinculatedFields: undefined,
                label: this.appName === 'vginer' ? 'Fertilizante' : 'Nombre o Marca Comercial',
                input: { type: InputType.TEXT, isEditable: this.isEditable() },
                width: 4,
                conditions: this.conditions({ isRequired: this.fertilizantesNombreRequired }),
                order: 1,
            },
            {
                name: 'familia',
                vinculatedFields: undefined,
                label: 'Familia',
                input: { type: InputType.TEXT, isEditable: this.isEditable() },
                width: 4,
                conditions: this.conditions({ isVisible: this.appName === 'agroleza' }),
                order: 2,
            },
            {
                name: 'descripcion',
                vinculatedFields: undefined,
                label: this.appName === 'agropecuariaramirogruas' ? 'Descripción (Tipo Fertilizante)' : 'Descripción',
                input: { type: InputType.TEXTAREA, isEditable: this.isEditable() },
                width: 4,
                conditions: this.conditions({ isVisible: this.showDescripcion }),
                order: 3,
            },
            {
                name: 'composicion',
                vinculatedFields: undefined,
                label: 'Composición',
                input: { type: InputType.TEXT, isEditable: this.isEditable() },
                width: 4,
                conditions: this.conditions({ isVisible: this.showFertisComposicion }),
                order: 4,
            },
        ];

        this.appendVisibleFields(topFields);
        return topFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }// getTopFields();

    /**
     * Builds and returns the fertilizer commercial and stock fields.
     *
     * @public
     *
     * @returns The left column fields sorted by display order.
     */
    public getLeftFields(): FormField<ProductosModel>[] {
        const leftFields: FormField<ProductosModel>[] = [
            {
                name: 'precio',
                vinculatedFields: undefined,
                label: this.appName === 'agrotata' ? 'Precio Coste' : 'Precio',
                input: { type: InputType.NUMERIC, isEditable: this.isEditable() },
                width: 6,
                conditions: this.conditions({ isVisible: this.showPrecio }),
                order: 1,
            },
            {
                name: 'precio_venta',
                vinculatedFields: undefined,
                label: 'Precio de Venta',
                input: { type: InputType.NUMERIC, isEditable: this.isEditable() },
                width: 6,
                conditions: this.conditions({ isVisible: this.showPrecio && this.appName === 'agrotata' }),
                order: 2,
            },
            {
                name: 'unidades',
                vinculatedFields: undefined,
                label: 'Unidades medida',
                input: {
                    type: InputType.DROPDOWN,
                    isEditable: this.isEditable(),
                    data: this.lists.unidadesCostes,
                },
                width: 6,
                conditions: this.conditions({ isRequired: true }),
                order: 3,
            },
            {
                name: 'envase',
                vinculatedFields: undefined,
                label: 'Envase',
                input: { type: InputType.TEXT, isEditable: this.isEditable() },
                width: 6,
                conditions: this.conditions(),
                order: 4,
            },
            {
                name: 'tipo_abono_organico',
                vinculatedFields: undefined,
                label: 'Tipo de Abono Orgánico',
                input: {
                    type: InputType.DROPDOWN,
                    isEditable: this.isEditable(),
                    data: this.lists.tiposAbonoOrganico,
                },
                width: 6,
                conditions: this.conditions(),
                order: 5,
            },
            {
                name: 'abono_con_inhibidor',
                vinculatedFields: undefined,
                label: 'Abono con inhibidor de Nitrógeno',
                input: { type: InputType.SWITCH, isEditable: this.isEditable() },
                width: 6,
                conditions: this.conditions(),
                order: 6,
            },
            {
                name: 'rotura_stock',
                vinculatedFields: undefined,
                label: 'Rotura stock',
                input: { type: InputType.NUMERIC, isEditable: this.isEditable() },
                width: 6,
                conditions: this.conditions({ isVisible: this.showRoturaStock }),
                order: 7,
            },
            {
                name: 'subtipo',
                vinculatedFields: undefined,
                label: 'Subtipo',
                input: {
                    type: InputType.DROPDOWN,
                    isEditable: this.isEditable(),
                    data: this.lists.subtipos,
                },
                width: 6,
                conditions: this.conditions({ isVisible: this.showFertilizantesSubtipo }),
                order: 8,
            },
        ];

        this.appendVisibleFields(leftFields);
        return leftFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }// getLeftFields();

    /**
     * Builds and returns the fertilizer NPK and secondary nutrient fields.
     *
     * @public
     *
     * @returns The right column fields sorted by display order.
     */
    public getRightFields(): FormField<ProductosModel>[] {
        const rightFields: FormField<ProductosModel>[] = [
            this.buildNumericField('N', 'N%', 1, 2, this.showFertilizantesNPK),
            this.buildNumericField('P', 'P%', 2, 2, this.showFertilizantesNPK),
            this.buildNumericField('K', 'K%', 3, 2, this.showFertilizantesNPK),
            this.buildNumericField('Ca', 'Ca%', 4, 2, this.showFertilizantesCa),
            this.buildNumericField('S', 'S%', 5, 2, this.showFertilizantesS),
            this.buildNumericField('Mg', 'Mg%', 6, 2, this.showFertilizantesMg),
        ];

        this.appendVisibleFields(rightFields);
        return rightFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }// getRightFields();

    /**
     * Builds and returns the supplier company fields.
     *
     * @public
     *
     * @returns The company fields sorted by display order.
     */
    public getEmpresaFields(): FormField<ProductosModel>[] {
        const fieldName = this.formType < FormType.DELETION ? 'id_comercio' : 'comercio_nombre';
        const isEditable = this.isEditable();
        const empresaFields: FormField<ProductosModel>[] = [
            {
                name: fieldName,
                vinculatedFields: undefined,
                label: 'Empresa Suministradora',
                input: {
                    type: isEditable ? InputType.DROPDOWN : InputType.ONLY_TEXT,
                    isEditable,
                    data: this.lists.empresa,
                    dropdownConfiguration: { valuePrimaryKey: 'id' },
                },
                width: 3,
                conditions: this.conditions(),
                order: 1,
            },
        ];

        this.appendVisibleFields(empresaFields);
        return empresaFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }// getEmpresaFields();

    /**
     * Builds and returns the fertilizer material macronutrient fields.
     *
     * @public
     *
     * @returns The macronutrient fields sorted by display order.
     */
    public getMaterialFertiFields(): FormField<ProductosModel>[] {
        const materialFertiFields: FormField<ProductosModel>[] = [
            {
                name: 'material_ferti',
                vinculatedFields: undefined,
                label: 'Material Fertilizante',
                input: {
                    type: InputType.DROPDOWN_SEARCH,
                    isEditable: this.isEditable(),
                    data: this.lists.materialFertilizante,
                },
                width: 3,
                conditions: this.conditions(),
                order: 1,
            },
            this.buildMaterialField('n_total', 'macronutriente_1', 'N Total', 2),
            this.buildMaterialField('n_organico', 'macronutriente_3', 'N Orgánico', 3),
            this.buildMaterialField('n_nitrico', 'macronutriente_2', 'N Nítrico', 4),
            this.buildMaterialField('n_amoniacal', 'macronutriente_4', 'N Amoniacal', 5),
            this.buildMaterialField('n_ureico', 'macronutriente_5', 'N Ureico', 6),
            this.buildMaterialField('p2o5_total', 'macronutriente_6', 'P2O5 Total', 7),
            this.buildMaterialField('p2o5_agua', 'macronutriente_7', 'P205 Soluble en Agua', 8),
            this.buildMaterialField(
                'p2o5_amonico',
                'macronutriente_8',
                'P205 Soluble en Citrato Amónico Neutro y Agua',
                9,
                this.applicationType !== 'cropgest',
            ),
            this.buildMaterialField('k20_total', 'macronutriente_9', 'K20 Total', 10),
            this.buildMaterialField('materia_organica', 'macronutriente_10', 'Materia orgánica', 11),
            this.buildMaterialField('calcio', 'macronutriente_11', 'Calcio (CaO)', 12, this.applicationType !== 'cropgest'),
            this.buildMaterialField('nombre_tipo', 'macronutriente_12', 'Nombre del Tipo', 13, this.applicationType !== 'cropgest'),
            this.buildMaterialField('dosis', 'macronutriente_13', 'Dosis', 14, this.applicationType !== 'cropgest'),
            this.buildMaterialField(
                'tratamiento_recibido',
                'macronutriente_15',
                'Tratamiento Recibido',
                15,
                this.applicationType !== 'cropgest',
            ),
        ];

        this.appendVisibleFields(materialFertiFields);
        return materialFertiFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }// getMaterialFertiFields();

    /**
     * Builds and returns heavy metal fields.
     *
     * @public
     *
     * @returns The heavy metal fields sorted by display order.
     */
    public getMetalesPesadosFields(): FormField<ProductosModel>[] {
        const metalesPesadosFields: FormField<ProductosModel>[] = [
            this.buildNumericField('m_cadmio', 'Cadmio (Cd)', 1, 3),
            this.buildNumericField('m_cobre', 'Cobre (Cu)', 2, 3),
            this.buildNumericField('m_plomo', 'Plomo (Pb)', 3, 3),
            this.buildNumericField('m_niquel', 'Niquel (Ni)', 4, 3),
            this.buildNumericField('m_zinc', 'Zinc (Zn)', 5, 3),
            this.buildNumericField('m_mercurio', 'Mercurio (Hg)', 6, 3),
            this.buildNumericField('m_cromo_total', 'Cromo total (Cr)', 7, 3),
        ];

        this.appendVisibleFields(metalesPesadosFields);
        return metalesPesadosFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }// getMetalesPesadosFields();

    /**
     * Builds and returns hidden fields required by product submit actions.
     *
     * @public
     *
     * @returns The hidden fields sorted by display order.
     */
    public getHiddenFields(): FormField<ProductosModel>[] {
        const hiddenFields: FormField<ProductosModel>[] = [
            {
                name: 'id',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    isEditable: false,
                    defaultValue: this.getHiddenFieldDefaultValue('id'),
                },
                width: 0,
                conditions: this.conditions({ isVisible: true }),
                order: 1,
            },
            {
                name: 'id_cliente',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    isEditable: false,
                    defaultValue: this.getHiddenFieldDefaultValue('id_cliente'),
                },
                width: 0,
                conditions: this.conditions({ isVisible: true }),
                order: 2,
            },
            {
                name: 'tipo',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    isEditable: false,
                    defaultValue: 'fertilizante',
                },
                updateValue: () => this.resolveProductType(this.model.tipo),
                width: 0,
                conditions: this.conditions({ isVisible: true }),
                order: 3,
            },
            {
                name: 'imagen',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    isEditable: false,
                    defaultValue: this.getHiddenFieldDefaultValue('imagen'),
                },
                updateValue: () => this.model.imagen,
                width: 0,
                conditions: this.conditions({ isVisible: this.appName === 'agroleza' }),
                order: 4,
            },
        ];

        return hiddenFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }// getHiddenFields();

    /**
     * Builds and returns all fertilizer product form sections.
     *
     * @private
     *
     * @returns The form sections sorted by display order.
     */
    private getFormSections(): FormSection<ProductosModel>[] {
        const sections: FormSection<ProductosModel>[] = [
            {
                name: 'Datos del fertilizante',
                width: 12,
                isVisible: true,
                fields: this.getFertilizerFields(),
                order: 1,
            },
            {
                name: 'Empresa',
                width: 12,
                isVisible: this.applicationType === 'cropgest' && this.appName !== 'agroleza',
                fields: this.getEmpresaFields(),
                order: 2,
            },
            {
                name: 'Macronutrientes',
                width: 12,
                isVisible: this.applicationType === 'cropgest' || this.activateREA,
                fields: this.getMaterialFertiFields(),
                order: 3,
            },
            {
                name: 'Metales Pesados',
                width: 12,
                isVisible: this.applicationType === 'cropgest' || this.activateREA,
                fields: this.getMetalesPesadosFields(),
                order: 4,
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getHiddenFields(),
                order: 5,
            },
        ];

        return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }// getFormSections();

    /**
     * Builds the root form metadata object.
     *
     * @private
     *
     * @param table - Optional table configuration used by table-based form modes.
     * @param actions - Optional callbacks used by header buttons.
     *
     * @returns The root form metadata object.
     */
    private buildForm(table: (string[] | string[][])[] | null): Form<ProductosModel> {
        return {
            name: 'productos',
            header: this.getHeader(),
            type: this.formType,
            sections: this.getFormSections(),
            table: table === null
                ? null
                : { title: '', showIndex: false, data: table?.[0], style: table?.[1] },
            uploadButton: {
                isEnabled: this.appName === 'agroleza' && this.isEditable(),
                label: 'Añadir imagen',
            },
            signed: false,
        };
    }// buildForm();

    /**
     * Creates field conditions using the project defaults.
     *
     * @private
     *
     * @param overrides - Partial condition values to override defaults.
     *
     * @returns A complete field conditions object.
     */
    private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
        return {
            isRememberedOnDuplicate: false,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true,
            ...overrides,
        };
    }// conditions();

    /**
     * Appends visible fields to table/export metadata arrays.
     *
     * @private
     *
     * @param fields - Fields to inspect and append when visible.
     *
     * @returns Nothing.
     */
    private appendVisibleFields(fields: FormField<ProductosModel>[]): void {
        const visibleFields = fields.filter((field) => field.conditions.isVisible && field.input.type !== InputType.EMPTY);

        this.fieldNames = this.fieldNames.concat(visibleFields);
        this.fieldLabels = this.fieldLabels.concat(visibleFields.map((field) => field.label));
    }// appendVisibleFields();

    /**
     * Returns the form header based on the active form mode.
     *
     * @private
     *
     * @returns Human-readable form header.
     */
    private getHeader(): string {
        switch (this.formType) {
            case FormType.CREATION:
                return 'Crear fertilizante';
            case FormType.DUPLICATION:
                return 'Duplicar fertilizante';
            case FormType.EDITION:
                return 'Editar fertilizante';
            default:
                return 'Datos del fertilizante';
        }
    }// getHeader();

    /**
     * Converts backend switch variants to the numeric values expected by PrimeNG.
     *
     * @private
     *
     * @param value - Raw switch value received from the form or backend.
     *
     * @returns `1` when enabled, otherwise `0`.
     */
    private normalizeSwitchValue(value: unknown): 1 | 0 {
        if (value === 1 || value === true) {
            return 1;
        }// if();

        if (typeof value === 'string') {
            const normalizedValue = value.trim().toLowerCase();

            return ['1', 'true', 'si', 'sí', 's', 'yes'].includes(normalizedValue) ? 1 : 0;
        }// if();

        return 0;
    }// normalizeSwitchValue();

    /**
     * Keeps fertilizer products grouped correctly in list and dropdown queries.
     *
     * @private
     *
     * @param value - Raw product type value.
     *
     * @returns A non-empty product type.
     */
    private resolveProductType(value: unknown): string {
        const normalizedValue = value === null || value === undefined ? '' : String(value).trim();

        return normalizedValue !== '' ? normalizedValue : 'fertilizante';
    }// resolveProductType();

    /**
     * Indicates whether normal fields can be edited in the current form mode.
     *
     * @private
     *
     * @returns True for creation, edition and duplication modes.
     */
    private isEditable(): boolean {
        return this.formType < FormType.DELETION;
    }// isEditable();

    /**
     * Builds a regular numeric field.
     *
     * @private
     *
     * @param name - Field name used by the model.
     * @param label - Human-readable field label.
     * @param order - Display order inside the current section.
     * @param width - Grid width.
     * @param isVisible - Field visibility flag.
     *
     * @returns A numeric form field.
     */
    private buildNumericField(
        name: string,
        label: string,
        order: number,
        width: number,
        isVisible = true,
    ): FormField<ProductosModel> {
        return {
            name,
            vinculatedFields: undefined,
            label,
            input: { type: InputType.NUMERIC, isEditable: this.isEditable() },
            width,
            conditions: this.conditions({ isVisible }),
            order,
        };
    }// buildNumericField();

    /**
     * Builds a material field whose input type depends on the selected material.
     *
     * @private
     *
     * @param name - Field name used by the model.
     * @param placeholder - Material placeholder used by the dynamic resolver.
     * @param label - Human-readable field label.
     * @param order - Display order inside the current section.
     * @param isVisible - Field visibility flag.
     *
     * @returns A dynamic material form field.
     */
    private buildMaterialField(
        name: string,
        placeholder: string,
        label: string,
        order: number,
        isVisible = true,
    ): FormField<ProductosModel> {
        const defaultType = this.isEditable() ? InputType.TEXT : InputType.ONLY_TEXT;
        const initialType = this.getMaterialFieldInputTypeByPlaceholder(placeholder, this.model.material_ferti, defaultType);

        return {
            name,
            vinculatedFields: ['material_ferti'],
            label,
            input: {
                type: initialType,
                isEditable: this.isEditable(),
                placeholder,
                dynamicTypeConfiguration: {
                    dependsOn: 'material_ferti',
                    defaultType,
                    resolver: (context) => this.getMaterialFieldInputType(
                        context.field,
                        context.model.get('material_ferti')?.value,
                        context.defaultType,
                    ),
                },
            },
            width: 3,
            conditions: this.conditions({ isVisible }),
            order,
        };
    }// buildMaterialField();

    /**
     * Resolves a dynamic material field input type from the current material value.
     *
     * @private
     *
     * @param field - Dynamic form field.
     * @param materialValueRaw - Raw selected material value.
     * @param defaultType - Type to use when the field must be visible.
     *
     * @returns The resolved input type.
     */
    private getMaterialFieldInputType(
        field: FormField<ProductosModel>,
        materialValueRaw: unknown,
        defaultType: InputType,
    ): InputType {
        return this.getMaterialFieldInputTypeByPlaceholder(
            field.input.placeholder ?? '',
            materialValueRaw,
            defaultType,
        );
    }// getMaterialFieldInputType();

    /**
     * Resolves a dynamic material field input type from a placeholder.
     *
     * @private
     *
     * @param placeholder - Placeholder used to identify the material field group.
     * @param materialValueRaw - Raw selected material value.
     * @param defaultType - Type to use when the field must be visible.
     *
     * @returns The resolved input type.
     */
    private getMaterialFieldInputTypeByPlaceholder(
        placeholder: string,
        materialValueRaw: unknown,
        defaultType: InputType,
    ): InputType {
        const materialValue = this.getMaterialValue(materialValueRaw);

        if (materialValue === '') {
            return InputType.EMPTY;
        }// if();

        const selectedRule = this.materialRules.find((rule) => rule.materialValues.includes(materialValue));

        if (selectedRule === undefined) {
            return InputType.EMPTY;
        }// if();

        return selectedRule.visiblePlaceholders.includes(placeholder) ? defaultType : InputType.EMPTY;
    }// getMaterialFieldInputTypeByPlaceholder();

    /**
     * Extracts the selected material code from dropdown objects, labels or scalar values.
     *
     * @private
     *
     * @param materialValueRaw - Raw selected material value.
     *
     * @returns The selected material code or an empty string.
     */
    private getMaterialValue(materialValueRaw: unknown): string {
        if (materialValueRaw === null || materialValueRaw === undefined) {
            return '';
        }// if();

        if (typeof materialValueRaw === 'object') {
            const materialRecord = materialValueRaw as Record<string, unknown>;
            const objectValue = materialRecord['value'] ?? materialRecord['id'];

            return objectValue === null || objectValue === undefined ? '' : String(objectValue);
        }// if();

        const materialValue = String(materialValueRaw);
        const materialOption = this.lists.materialFertilizante.filtered.find((option) =>
            String(option.value ?? '') === materialValue || option.label === materialValue,
        );

        if (materialOption !== undefined) {
            return materialOption.value === null || materialOption.value === undefined ? '' : String(materialOption.value);
        }// if();

        return materialValue;
    }// getMaterialValue();

    /**
     * Reads a scalar hidden field default value from the current model.
     *
     * @private
     *
     * @param name - Hidden field name.
     *
     * @returns The default value for the hidden field.
     */
    private getHiddenFieldDefaultValue(name: string): string | number | boolean | null | undefined {
        const value = (this.model as Record<string, unknown>)[name];

        if (value === null || value === undefined) {
            return null;
        }// if();

        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            return value;
        }// if();

        return String(value);
    }// getHiddenFieldDefaultValue();

}// class;
